import {
  Container,
  Stack,
  LinearProgress,
} from '@mui/material';
import React from 'react';
import useGetInputParams from './hooks/useGetInputParams';
import useFormatElementData from './hooks/useFormatElementData';
import useLanguageList from './hooks/useLanguageList';
import useFilter from './hooks/useFilter';
import RequieredSearchField from './components/RequieredSearchField';
import AdditionalSearchField from './components/AdditionalSearchField';
import useFetchLabPatientList from './hooks/useFetchLabPatientList';
import LabPatientList from './components/LabPatientList';

const Pato = () => {
  const data = useGetInputParams();

  const [patoType, noeTaeed] = useFormatElementData(data);

  const [
    label_combo_label,
    label_confirm_type,
    label_date_insert,
    label_file_number,
    label_patient_number_request,
    label_patient_name_patient,
    label_patient_family_patient,
    lab_patient_patient_id_textbox,
  ] = useLanguageList();

  const { filterData, setFilter } = useFilter();
  const listPatient = useFetchLabPatientList(filterData);

  return (
    <React.Fragment>
      <Container>
        {patoType ? (
          <Stack gap=".5em" mt="1em">
            <RequieredSearchField
              setFilter={setFilter}
              labType={patoType}
              noeTaeed={noeTaeed}
              label_combo_label={label_combo_label}
              label_confirm_type={label_confirm_type}
            />

            <AdditionalSearchField
              setFilter={setFilter}
              label_patient_number_request={
                label_patient_number_request
              }
              label_patient_name_patient={
                label_patient_name_patient
              }
              label_patient_family_patient={
                label_patient_family_patient
              }
              label_file_number={label_file_number}
              lab_patient_patient_id_textbox={
                lab_patient_patient_id_textbox
              }
            />
          </Stack>
        ) : (
          <LinearProgress />
        )}
        {listPatient === 'loading' ? (
          <LinearProgress sx={{ mt: '1em' }} />
        ) : (
          <LabPatientList listPatient={listPatient} />
        )}
      </Container>
    </React.Fragment>
  );
};

export default Pato;
